import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@artosera/ui';
import { AuditTable } from '../components/AuditTable.js';
import pageStyles from '../styles/page.module.css';
import tableStyles from '../styles/table.module.css';

export function AuditGlobal(): JSX.Element {
  const { t } = useTranslation('console');
  const [galerie, setGalerie] = useState('');

  return (
    <section>
      <div className={pageStyles.entete}>
        <div>
          <h1>{t('journal.titre')}</h1>
          <p>{t('journal.texte')}</p>
        </div>
      </div>
      <div className={tableStyles.toolbar}>
        <div className={tableStyles.champFiltre}>
          <label htmlFor="journal-filtre-galerie">{t('journal.filtreGalerie')}</label>
          <Input
            id="journal-filtre-galerie"
            value={galerie}
            onChange={(event) => setGalerie(event.target.value)}
          />
        </div>
      </div>
      <AuditTable galerie={galerie.trim() || undefined} />
    </section>
  );
}
